import { FormatStyle, FontStyle, ConditionalConfig } from 'common/visualizations/views/agGridReact/types';
import { FILTER_FUNCTION } from 'common/components/FilterBar/SoqlFilter';
import { ViewColumn } from 'common/types/viewColumn';
import { SoQLType } from 'common/types/soql';
import { get, isEqual } from 'lodash';

export const defaultFontStyle = (): FontStyle => ({
  isBold: false,
  isItalic: false,
  isWrapped: false
});

export const defaultConditionStyle = (): FormatStyle => ({
  backgroundColor: '#ffffff',
  textColor: '#000000',
  textFont: '',
  fontStyle: defaultFontStyle()
});

export const defaultConditionalConfig = (isDate = false): ConditionalConfig => ({
  expression: {
    function: isDate ? FILTER_FUNCTION.TIME_RANGE : FILTER_FUNCTION.EQUALS,
    arguments: {
      start: '',
      end: '',
      value: ''
    }
  },
  style: defaultConditionStyle()
});

export const getDataTypeName = (viewColumn: ViewColumn) => {
  return get(viewColumn, 'dataTypeName', SoQLType.SoQLTextT);
};

export const getColumnDataTypeInfo = (dataTypeName: SoQLType) => {
  return {
    dataType: dataTypeName,
    isNumberRenderType: isEqual(dataTypeName, SoQLType.SoQLNumberT),
    isBooleanRenderType: isEqual(dataTypeName, SoQLType.SoQLBooleanT),
    isDateRenderType: [
      SoQLType.SoQLFixedTimestampT,
      SoQLType.SoQLFixedTimestampAltT,
      SoQLType.SoQLFloatingTimestampT,
      SoQLType.SoQLFloatingTimestampAltT
    ].includes(dataTypeName)
  };
};
